<template>
<!--    <RichResponseHeadline-->
<!--        :title="headline ?? ''"-->
<!--        class="headline"-->
<!--    />-->
    <MonthKpiOverview :selectedMonth="props.initData as kapitelMonthString" />
</template>

<script setup lang="ts">

import {computed, PropType} from "vue";
import RichResponseHeadline from "@/views/Chat/RichResponses/components/RichResponseHeadline.vue";
import {kapitelDateString, kapitelMonthString} from "@/graphql/kapitelTypes";
import {formatMonthFromKapitelDate, getYearFromKapitelDate} from "@/helper/datetime/date";

import MonthKpiOverview from "@/views/components/MonthKPI/MonthKPIOverview.vue";

const props = defineProps({
    // month start
    initData: {
        type: String as PropType<kapitelDateString>,
        required: true
    },
    headline: {
        type: [String, null] as PropType<string|null>,
        required: false,
        default: (props:{initData:kapitelDateString}) => `${formatMonthFromKapitelDate(props.initData)} ${getYearFromKapitelDate(props.initData)}`
    }
})

</script>
<style lang="scss" scoped>
</style>
